module.exports = __webpack_public_path__ + "static/media/paniers.3438ec7d.png";